import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport, WizModal} = component_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      'Follow': '关注',
      'Comment': '评论',
      'At': '@我',
      'Praise': '点赞',
      'Collect': '收藏',
    },
  }
  return values[type][key]
}

class ShortVideoMessageManager extends WizContainer {
  componentName = 'shortVideoMessageManager'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '消息接收人',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '帐号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '通知类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '通知内容',
        field: 'title',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '通知时间',
        field: 'msgTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['type'] = _getValue('type', e['type'])
      })
      WizBrowserExport({
        title: '短视频消息信息',
        sheetName: '短视频消息信息',
        columns: columnDefs,
        rows: data,
        filename: '短视频消息信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ShortVideoMessageManager);
